__webpack_require__.p = "/WR-react-portfolio/";